import React, { useState, useEffect } from "react";
import EditInputsUi from "../../../ui/InputsUi/EditInputsUi";
import { useParams } from "react-router-dom";
import { typeOfInputs } from "../../../lib/definitions";
import { GetInputsByIdData } from "../../../lib/data";
import i18n from "../../../lib/i18n";

export default function EditInputs () {

    const {inputId} = useParams();
    const [inputsData, setInputsData] = useState({});
    const t = i18n.t.bind(i18n); 

    useEffect(() => {
        handleApi();
    }, [])

    const handleApi = async () => {
        const inputData = await GetInputsByIdData(inputId);
        setInputsData([]);
        setInputsData(inputData);
    };

    return(
        <div className="p-5 my-3 mx-6 rounded-lg bg-thirdly">
            <div>
                <h1 className="sm:text-[30px] text-[24px] text-center text-gray pt-1 sm:pb-8 pb-4"> {t("edit_page_title.input")}  ({inputId})</h1>
                <EditInputsUi typeOfInputs={typeOfInputs} inputId={inputId} inputsData={inputsData} />
            </div>
        </div>
    );
};